/**
 * Frontend contract types for the assistant guide/helper posture (Epic 4, story 4.6).
 *
 * The exact posture string values below are ASSUMPTIONS about the stored/server values, mirrored from
 * the (separate-repo) backend assistant epics. They are confined to this file + `assistant-posture.service.ts`
 * and enumerated in BACKEND-CONTRACT.md. Confirm/replace them per that runbook.
 */

/**
 * BACKEND CONTRACT (assumption) — see BACKEND-CONTRACT.md
 * The two assistant postures. `guide` walks the user through onboarding; `helper` answers on demand.
 * The toggle switches between exactly these two, and the stored value is authoritative.
 */
export enum AssistantPosture {
  // BACKEND CONTRACT (assumption) — see BACKEND-CONTRACT.md
  Guide = 'guide',
  // BACKEND CONTRACT (assumption) — see BACKEND-CONTRACT.md
  Helper = 'helper',
}

/** The opposite posture — what the toggle switches to. Pure. */
export function oppositePosture(posture: AssistantPosture): AssistantPosture {
  return posture === AssistantPosture.Guide ? AssistantPosture.Helper : AssistantPosture.Guide
}

/**
 * Validate a raw backend value into an `AssistantPosture`, or `undefined` when it is not a known posture
 * string. Keeps the exact posture strings isolated here so a body missing/omitting a valid posture never
 * advances `posture$` to a bogus value. Pure — unit-tested.
 */
export function parsePosture(value: unknown): AssistantPosture | undefined {
  if (value === AssistantPosture.Guide) return AssistantPosture.Guide
  if (value === AssistantPosture.Helper) return AssistantPosture.Helper
  return undefined
}
